var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-text-input" },
    [
      _vm.label
        ? _c(
            "label",
            { staticClass: "c-text-input__label", attrs: { for: _vm.formId } },
            [_vm._v(_vm._s(_vm.label))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default"),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.localValue,
            expression: "localValue"
          }
        ],
        ref: "form-input-ref",
        staticClass: "c-text-input__control t-heading-7",
        class: _vm.iconClass,
        attrs: {
          type: "text",
          autocomplete: _vm.autocomplete,
          disabled: _vm.disabled,
          maxlength: _vm.inputMaxLength,
          name: _vm.formId,
          placeholder: _vm.placeholder,
          required: _vm.required
        },
        domProps: { value: _vm.localValue },
        on: {
          blur: function($event) {
            return _vm.$emit("blur", $event)
          },
          focus: function($event) {
            return _vm.$emit("focus", $event)
          },
          keydown: function($event) {
            return _vm.$emit("keydown", $event)
          },
          keyup: function($event) {
            return _vm.$emit("keyup", $event)
          },
          mouseup: function($event) {
            return _vm.$emit("mouseup", $event)
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.localValue = $event.target.value
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }